// extracted by mini-css-extract-plugin
export var caret = "NearbyLocation-module--caret--2b7c5";
export var caretUp = "NearbyLocation-module--caret-up--ca29d";
export var clinic = "NearbyLocation-module--clinic--7e0b8";
export var clinicName = "NearbyLocation-module--clinic-name--c9e69";
export var isSelected = "NearbyLocation-module--is-selected--00ade";
export var seeMore = "NearbyLocation-module--see-more--c45f6";
export var seeMoreContainer = "NearbyLocation-module--see-more-container--b0ef0";
export var slotButton = "NearbyLocation-module--slot-button--683bf";
export var slotItem = "NearbyLocation-module--slot-item--f3318";
export var slotsButtons = "NearbyLocation-module--slots-buttons--6b0ce";